import React from 'react';

export const PageTransfersAchBatchView: React.FC = () => {
  return null;
};
